import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalPartnerTagForm from '../containers/JournalPartnerTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalPartnerTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalPartnerTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_partner_tag_route_edit')} />
          <JournalPartnerTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalPartnerTagEditScreen;

Logger.log('silly', `JournalPartnerTagEditScreen loaded.`);